<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Ticket Id: {{ticketId}} <span class="close"
                                                                  (click)="c()" aria-hidden="true">&times;</span>
        </div>

    </div>
    <div class="modal-body modal-height pad-top-0">
        <mat-tab-group [selectedIndex]='selectedIndextab' (selectedTabChange)="tabClick($event)">
            <mat-tab *ngIf="!ticketTab" label="Ticket Details">
                <div *ngIf="!ticketTab">
                    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif"
                                                                   src="../../../assets/img/loader.gif"></div>
                    <div class="row mar-lft-rgt-0">
                        <div class="col-md-12 pad-7">
                            <div class="height-40" [hidden]="categoryLoaded">
                                <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
                            </div>
                            <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;"
                                    [disabled]="ticket.isDisabled || isLowestLevel "
                                    (change)="onTicketChange(ticket,$event.target.value)" [hidden]="!categoryLoaded" id="ticket_{{ticket.id}}">
                                <option *ngFor="let option of ticket.options"
                                        [value]="option|json" [selected]="option.selected">{{option.title}}</option>
                            </select>
                        </div>
                    </div>

                    <div class=" mar-lft-rgt-0">
                        <div class="row col-sm-12" style=" margin-left: 5px;">
                            <div class="col-sm-6" *ngFor="let field of dynamicFields;" [ngSwitch]="field.fieldType">
                                <i [ngClass]="field.isQuestion? ' ' : 'col-sm-12'" *ngSwitchCase="'1'" [hidden]="field.isQuestion" type="text" class="form-control radius-0 font-13 marginTop"></i>
                                <div class="col-sm-6" *ngSwitchCase="'4'">
                                    <mat-form-field class="col-sm-2 matcss">
                                        <mat-label>{{field.fieldName}}</mat-label>
                                        <mat-select [(ngModel)]="field.value">
                                            <mat-option *ngFor="let opt of field.values" [value]="opt"
                                            >{{opt}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="form-group  marginTop" *ngSwitchCase="'1'" [hidden]="!field.isQuestion">
                                    <div class="row margin2">

                                        <label class="col-sm-7 col-form-label label1 ">{{field.fieldName}}</label>
                                        <div class="col-sm-5">
                                            <div class="form-group">
                                                <input type="text" class="form-control radius-0 font-13 " [(ngModel)]="field.value" (keypress)="blockSpecialChar($event)" maxlength="200"/>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="form-group  marginTop" *ngSwitchCase="'7'" [hidden]="!field.isQuestion">
                                    <div class="row margin2">

                                        <label class="col-sm-6 col-form-label label1 ">{{field.fieldName}}</label>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <textarea class="form-control radius-0 font-13 heighttxt" [(ngModel)]="field.value"
                                                          (keypress)="blockSpecialChar($event)" maxlength="200" (keypress)="blockSpecialChar($event)" maxlength="200" mwlResizable
                                                          [enableGhostResize]="false"
                                                          resizeCursorPrecision="100"
                                                          [resizeEdges]="{bottom: true, right: false, top: false, left: false}"
                                                          (resizeEnd)="onResizeEnd($event)"
                                                          [style.height.px]="height"></textarea>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-sm-6" *ngSwitchCase="'2'">
                                    <div class="row margin2 date-type">
                                        <div class="form-group">
                                            <!-- <input class="form-control radius-0 font-13 marginTop datecss" *ngIf = "field.value === '' || field.value === null"
                                                   placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                                                   [owlDateTime]="dt">
                                            <owl-date-time [pickerType]="'calendar'" #dt></owl-date-time> -->
                                            <input [hidden]="field.isQuestion || !ShowDate " class="form-control radius-0 font-13 marginTop datecss"
                                                placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                                                [owlDateTime]="dt" readonly [min]="min">
                                            <owl-date-time [pickerType]="'calendar'" #dt></owl-date-time>
                                        </div>
                                        <div class="form-group" [hidden]="ShowDate" >
                                            <input class="form-control radius-0 font-13 marginTop datecss" placeholder="{{field.fieldName}}" [(ngModel)]="field.value" readonly>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6" *ngSwitchCase="'5'">
                                    <div class="row margin2 date-type">
                                        <div class="form-group">
                                            <input [hidden]="!field.isQuestion" class="form-control radius-0 font-13 marginTop"
                                                   placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                                                   [owlDateTime]="dt">
                                            <owl-date-time [pickerType]="'timer'" #dt></owl-date-time>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6" *ngSwitchCase="'6'">
                                    <div class="row margin2 date-type">
                                        <div class="form-group">
                                            <input [hidden]="!field.isQuestion" class="form-control radius-0 font-13 marginTop"
                                                   placeholder="{{field.fieldName}}" [(ngModel)]="field.value" [owlDateTimeTrigger]="dt"
                                                   [owlDateTime]="dt">
                                            <owl-date-time #dt></owl-date-time>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="row mar-lft-rgt-0" *ngIf="parentDetails.length > 0">
                                <span class="type">Parent Id:</span> <span class="status">{{parentId}}</span>
                            </div>
                            <div class="row mar-lft-rgt-0" *ngIf="assetLists.length > 0">
                                <span class="type">Asset Ids: &nbsp;</span> <span class="status">{{assetIds}}</span>
                            </div>
                            <div class="row mar-lft-rgt-0">
                                <span class="type">Status:</span>&nbsp; <span class="status"
                                                                              (click)="statusClick('open')"
                                                                              [hidden]="defaultStatus || isCreateTicket || closedticket">{{statusName}}</span>
                                <span class="status" [hidden]="!isCreateTicket && !closedticket">{{statusName}}</span>
                                <!--&nbsp;<input type="text" class="col-sm-4 radius-0 font-13 formClass" [hidden]="!defaultStatus"-->
                                <!--placeholder="Status"> &nbsp;-->
                                <select class="custom-select col-sm-4 radius-0 font-13" [(ngModel)]="statusSelected"
                                        [hidden]="!defaultStatus"
                                        (change)="onStatusChange($event.target.selectedIndex)">
                                    <option *ngFor="let stat of status" [value]="stat.id">{{stat.name}}</option>
                                </select>&nbsp;
                                <select class="custom-select col-sm-4 radius-0 font-13" [hidden]="!isFollowUp"
                                        [(ngModel)]="followUpSelected"
                                >
                                    <option *ngFor="let follow of followUps"
                                            [value]="follow.id">{{follow.followup_users_name}}</option>
                                </select>&nbsp;
                                <input type="text" class="col-sm-4 radius-0 font-13 form-control"
                                       value="{{followupUser}}" title="{{followupUser}}" [hidden]="!hasFollowupUser"
                                       readonly>&nbsp;
                                <button type="button" class="btn btn-primary" (click)="setStatus()"
                                        [disabled]="statusDisabled "
                                        [hidden]="!defaultStatus"><i
                                        class="fa fa-check"
                                        aria-hidden="true"></i>
                                </button>&nbsp;
                                <button type="submit" class="btn btn-default" (click)="statusClick('close')"
                                        [hidden]="!defaultStatus"><i
                                        class="fa fa-times" aria-hidden="true"></i></button>

                            </div>
                            <div class="row mar-top-9">
                                <div class="form-group col-sm-12 desc-div">
                                    <input type="text" class="form-control radius-0 font-13" readonly
                                           placeholder="Enter Requester info (Ex. Name, phone number , email etc)"
                                           [(ngModel)]="name" title="{{name}}" [hidden]="seq===PROBLEM_TYPE_SEQ">

                                </div>
                                <div class="form-group col-sm-12 desc-div">
                                    <input type="text" class="form-control radius-0 font-13"
                                           placeholder="Ticket description" [(ngModel)]="desc" placement="right"
                                           title="{{desc}}" [readOnly]="true">
                                </div>
                                <div class="form-group col-sm-12 desc-div">
                                  <textarea
                                          class="form-control radius-0 font-13 ie-textarea desc-height edge-textarea"
                                          placeholder="Brief description" [(ngModel)]="brief" title="{{brief}}"
                                          [readOnly]="true" mwlResizable
                                          [enableGhostResize]="false"
                                          resizeCursorPrecision="10"
                                          [resizeEdges]="{bottom: true, right: true, top: false, left: false}"
                                          (resizeEnd)="onDescResizeEnd($event)"
                                          [style.height.px]="descHeight">

                                  </textarea>
                                </div>
                                <div class="form-group col-sm-6 desc-div "
                                     [hidden]="childTickets.length===0">
                                    <div class="card">
                                        <div class="card-header card-header-top font-13">
                                            <b> Child Tickets</b>
                                        </div>
                                        <div class="card-body row card-pad mar-lft-rgt-0 chipchildticket">
                                            <mat-form-field class="example-chip-list">
                                                <mat-chip-list #chipList aria-label="ticket selection">
                                                    <mat-chip *ngFor="let ticket of childTickets; let i of index;"
                                                              [selectable]="selectable"
                                                              [removable]="removable"
                                                              (removed)="deleteChildTicket(ticket.id, i)">
                                                        {{ticket.ticket_id}}
                                                        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                                                    </mat-chip>
                                                </mat-chip-list>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group col-sm-6 desc-div "
                                     [hidden]="assetDetails.length===0">
                                    <div class="card">
                                        <div class="card-header card-header-top font-13">
                                            <b> Attached Assets</b>
                                        </div>
                                        <div class="card-body row card-pad mar-lft-rgt-0 chipchildticket">
                                            <mat-form-field class="example-chip-list">
                                                <mat-chip-list #chipList1 aria-label="ticket selection">
                                                    <mat-chip *ngFor="let asset of assetDetails; let i of index;"
                                                              [selectable]="selectable">
                                                        {{asset.des}}
                                                    </mat-chip>
                                                </mat-chip-list>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row mar-lft-rgt-0 create-date">
                                    <!--<div class="col-sm-12">-->
                                        <!--<div class="form-group row">-->
                                            <label class="col-sm-5 col-form-label font-13">Created Date:</label>
                                            <div class="col-sm-7 cdate">
                                                <input class="form-control radius-0 font-13" value="{{rDate}}"
                                                        readonly title="{{rDate}}">
                                                <!--                                    <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>-->
                                            </div>
                                        <!--</div>-->

                                    <!--</div>-->
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6" *ngIf="!solTab">
                            <!--              <div class="col-sm">-->
                            <div class="card">
                                <div class="card-header card-header-top font-13">
                                    <b> Last Solution and Last Comment</b>
                                </div>
                                <div class="card-body row sla-card-pading mar-lft-rgt-0">
                                    <div class="form-group col-sm-9 pad-lft-0 desc-div">
                                      <textarea class="form-control radius-0 font-13 ie-textarea edge-textarea"
                                                placeholder="{{lastSol}}" [readonly]="!canAddSolution || isCancel"
                                                [(ngModel)]="solution"
                                                mwlResizable
                                                [enableGhostResize]="false"
                                                resizeCursorPrecision="10"
                                                [resizeEdges]="{bottom: true, right: true, top: false, left: false}"
                                                (resizeEnd)="onSolutionResizeEnd($event)"
                                                [style.height.px]="solutionHeight"
                                                [disabled]="isCreateTicket"
                                                maxlength="1000" title="{{lastSol}}"></textarea>
                                        <div class="warning-msg" [hidden]="!canAddSolution">
                                            *maximum 1000 characters
                                        </div>
                                    </div>
                                    <button type="button"
                                            class="btn btn-success col-sm-2 radius-0 font-13 height-52 solbtn"
                                            (click)="addSolution()"
                                            *ngIf="canAddSolution && !isCancel" [hidden]="isCreateTicket">
                                        Add Solution
                                    </button>
                                    <!--                                    <div class="height-40 " [hidden]="solLoaded">-->
                                    <!--                                        <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">-->
                                    <!--                                    </div>-->
                                    <div class="form-group mar-lft-rgt-0 row width-100 comment-top">
                                        <div class="col-sm-3 pad-lft-0">
                                            <p class=" custom-label pad-lft-rgt-0 mar-bot-0">Comment By:</p>
                                            <!--                                            <p class=" custom-label pad-lft-rgt-0 mar-bot-0">-->
                                            <!--                                                Comment By: </p>-->
                                            <span class="red custom-label">{{lastCommentUser}}</span>
                                        </div>
                                        <div class="col-sm-9 pad-lft-0 desc-div">
                                          <textarea type="text"
                                                    class="form-control font-13 radius-0 ie-textarea edge-textarea"
                                                    title="{{lastComment}}"
                                                    [(ngModel)]="lastComment"
                                                    mwlResizable
                                                    [enableGhostResize]="false"
                                                    resizeCursorPrecision="10"
                                                    maxlength="1000"
                                                    [resizeEdges]="{bottom: true, right: true, top: false, left: false}"
                                                    (resizeEnd)="onCommentResizeEnd($event)"
                                                    [style.height.px]="commentHeight"
                                                    readonly></textarea>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="card mar-top-9">
                                <div class="card-header card-header-top font-13">
                                    <b>People</b>
                                    <!--                                    <b class=" custom-label pad-lft-rgt-0 mar-bot-0 right">Escalation Level:-->
                                    <!--                                        <span class="blue custom-label">{{escLevel}}</span>-->
                                    <!--                                    </b>-->
                                </div>
                                <div class="card-body assign">
                                    <div class="row mar-lft-rgt-0">
                                        <span class="type">Assigned Group:</span>&nbsp; <span class="status"
                                                                                              (click)="nextUserClick('open')"
                                                                                              [hidden]="defaultNextUser">{{currentGroup}}</span>

                                        &nbsp;<select class="custom-select col-sm-4 radius-0 font-13"
                                                      [(ngModel)]="supportGroupSelected"
                                                      [hidden]="!defaultNextUser" (change)="onGroupChange()">
                                        <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
                                    </select>&nbsp;
                                        <span [hidden]="true">{{assignedGroup}}</span>
                                        <span [hidden]="true">{{assignedUser}}</span>
                                        <!--<button type="submit" class="btn btn-primary" [hidden]="!defaultNextUser"><i class="fa fa-check"-->
                                        <!--aria-hidden="true"></i>-->
                                        <!--</button>&nbsp;-->
                                        <button type="button" class="btn btn-default" (click)="nextUserClick('close')"
                                                [hidden]="!defaultNextUser">
                                            <i
                                                    class="fa fa-times" aria-hidden="true"></i></button>
                                    </div>
                                    <div class="row mar-top-15 mar-lft-rgt-0">
                                        <div class='col-sm-8 pad-lft-rgt-0'>
                                            <span class="type">Assigned User:</span>&nbsp; <span class="status"
                                                                                                 (click)="userClick('open')"
                                                                                                 [hidden]="defaultUser">{{currentUser}}</span>
                                            &nbsp;<select class="custom-select col-sm-4  radius-0 font-13"
                                                          [hidden]="!defaultUser"
                                                          [(ngModel)]="userSelected">
                                            <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
                                        </select>&nbsp;
                                            <!--<button type="submit" class="btn btn-primary" [hidden]="!defaultUser"><i class="fa fa-check"-->
                                            <!--aria-hidden="true"></i>-->
                                            <!--</button>&nbsp;-->
                                            <button type="submit" class="btn btn-default" (click)="userClick('close')"
                                                    [hidden]="!defaultUser">
                                                <i
                                                        class="fa fa-times" aria-hidden="true"></i></button>
                                        </div>
                                        <div class="col-sm-4 pad-lft-rgt-0" *ngIf="isSelfAssigned">
                                            <button (click)="selfAssign()" class="btn btn-success font-13 radius-0"
                                                    [hidden]="isCreateTicket">
                                                Assign to Self
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <!--              </div>-->
                        </div>
                    </div>
                    <div class="row mar-lft-rgt-0">
                        <div class="col-sm-6 pad-15 text-center" [hidden]="closedticket || solProvided">
                            <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                                                     [formData]="formdata"
                                                     [maxFile]="MAX_FILE_UPLOAD"
                                                     (uploadError)="onFileError($event)"
                                                     [isVisible]="!closedticket && !isCreateTicket"
                                                     (complete)="onFileComplete($event)"
                                                     (onFileAttach)="onFileAttach()"
                                                     (onFileRemove)="onRemove()"
                                                     (dataLoaded)="onUpload($event)"></app-material-fileupload>
                        </div>
                        <div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="hideAttachment">{{attachMsg}}
                            uploaded
                            successfully. Please click Update button to save it.
                        </div>
                        <!--<div class="col-sm-6 pad-15 text-center">{{attachment}}-->
                        <!--</div>-->
                    </div>
                    <div class="row mar-lft-rgt-0">
                        <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
                            <select class="custom-select font-13 radius-0" [(ngModel)]="impact" id="impactid">
                                <option *ngFor="let map of impacts" [value]="map.id">{{map.name}}</option>
                            </select>
                        </div>
                        <div class="col-sm-4 pad-15" *ngIf="priorityType===1">
                            <select class="custom-select font-13 radius-0" [(ngModel)]="urgency" id="urgencyid">
                                <option *ngFor="let map of urgencies" [value]="map.id">{{map.name}}</option>
                            </select>
                        </div>
                        <div class="col-sm-4 pad-15">
                            <select class="custom-select font-13 radius-0" [(ngModel)]="priorityId" id="priorityid">
                                <option *ngFor="let priority of priorityArr" [value]="priority.id">{{priority.priority}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mar-lft-rgt-0">
                        <div class="col-sm-4" *ngIf="!closedticket && !solProvided && !isCreateTicket">
                            <button type="button" class="btn btn-success radius-0 btn-block margintop"
                                    (click)="updateTicket()">Update Ticket
                            </button>
                        </div>
                        <div class="col-sm-4" *ngIf="ticketCreated && !isCreateTicket">
                            <button type="button" class="btn btn-danger radius-0 btn-block margintop"
                                    (click)="closeTicket()">Close Ticket
                            </button>
                        </div>
                        <div class="col-sm-3" *ngIf="cancelTicketBtn">
                            <button type="button" class="btn btn-danger radius-0 btn-block margintop"
                                    (click)="cancelTicket()">Cancel Ticket
                            </button>
                        </div>
                        <!-- <div class="col-sm-4"
                             *ngIf="!escalatedTicket && canForward && (statusSeq !== PROBLEM_SOLUTION_PROVIDED) && !isCreateTicket">
                            <button type="button" class="btn btn-primary radius-0 btn-block"
                                    (click)="forwardTicketWithMessage()">Forward Ticket
                            </button>
                        </div> -->

                        <div class="col-sm-4" *ngIf="escalatedTicket && !isCreateTicket">
                            <button type="button" class="btn btn-primary radius-0 btn-block"
                                    (click)="escalateTicket()">Re-open Ticket
                            </button>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab *ngIf="!commentsTab" label="Comments">
                <ng-template mat-tab-label>
                    Comments &nbsp;
                    <i class="fa fa-circle text-success" [hidden]="!displayNewComment"></i>
                </ng-template>
                <img class="loading-gif" src="../../../assets/img/loader.gif" [hidden]="comLoaded">
                <div class="mar-top-15 ">
                    <div class="col-sm-12">
                        <div class="form-group col-sm-12 textareadiv">
                <textarea class="form-control radius-0 font-13 ie-textarea sol-com-height edge-textarea"
                          placeholder="Put your comment here" [(ngModel)]="comment" maxlength="1000"
                          mwlResizable
                          [enableGhostResize]="false"
                          resizeCursorPrecision="10"
                          [resizeEdges]="{bottom: true, right: true, top: false, left: false}"
                          (resizeEnd)="onResizeCommentEnd($event)"
                          [style.height.px]="height"
                          [disabled]="isCreateTicket"></textarea>
                            <div class="warning-msg">
                                *maximum 1000 characters
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 sol-div" *ngIf="!isCreateTicket">
                        <button type="button" class="btn btn-success btn-block" (click)="addComment('comment')"
                                [disabled]="!canAddComment">
                            Add Comment
                        </button>
                    </div>
                    <div class="col-sm-12 mar-top-15">

                        <div class="stepper-container vertical">
                            <div class="stepper">
                                <div class="step step-height" *ngFor="let comment of comments;">
                                    <div class="step-inner">
                                        <div class="step-circle"><span><i class="fa fa-user"></i></span></div>
                                    </div>
                                    <div class="step-content col-sm-12 mar-top-15 mar-lft-rgt-0">
                                        <div class="card radius-0">
                                            <div class="card-header radius-0 card-header-top stepper-head">
                                                <b>{{comment.name}}</b>
                                                <b class="right"> {{comment.createddate| date:'medium'}}</b>
                                            </div>
                                            <div class="card-body">
                                                <pre>{{comment.feedback}}</pre>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab *ngIf="diplaySLAMeter" label="SLA Meter">
                <div class="mar-top-15 row mar-lft-rgt-0">
                    <div class="offset-2 col-sm-4">
                        <div class="card">
                            <div class="card-header card-header-top font-13">
                                <b>Response Meter</b>
                            </div>
                            <div class="card-body middle">
                                <circle-progress
                                        [percent]="respPercent"
                                        [radius]="70"
                                        [outerStrokeWidth]="10"
                                        [innerStrokeWidth]="5"
                                        [showSubtitle]="false"
                                        [outerStrokeColor]="outerColorResp"
                                        [innerStrokeColor]="innerColorResp"
                                        [animation]="true"
                                        [animationDuration]="300"
                                        [startFromZero]="false"
                                ></circle-progress>
                                <br>
                                <b class="font-13">Response Time: <span class="green">{{respTime}}</span></b><br>
                                <b class="sla-meter">SLA Violated:<span
                                        [ngClass]="slaViolatedResp?'red':'green'">{{slaStringResp}}</span></b><br>
                                <b class="font-13">SLA clock status: <span
                                        [ngClass]="reponseStatus?'green':'red'">{{respClockStatus}}</span></b>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4">
                        <div class="card">
                            <div class="card-header card-header-top font-13">
                                <b>Resolution Meter</b>
                            </div>
                            <div class="card-body middle">
                                <circle-progress
                                        [percent]="percent"
                                        [radius]="70"
                                        [outerStrokeWidth]="10"
                                        [innerStrokeWidth]="5"
                                        [showSubtitle]="false"
                                        [outerStrokeColor]="outerColor"
                                        [innerStrokeColor]="innerColor"
                                        [animation]="true"
                                        [animationDuration]="300"
                                        [startFromZero]="false"
                                ></circle-progress>
                                <br>
                                <b class="font-13">Resolution Time: <span class="green">{{resoTime}}</span></b><br>
                                <b class="sla-meter">SLA Violated:<span
                                        [ngClass]="slaViolated?'red':'green'">{{slaString}}</span></b><br>
                                <b class="font-13">SLA clock status: <span
                                        [ngClass]="resolutionStatus?'green':'red'">{{resoClockStatus}}</span></b>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab *ngIf="!solTab" label="Solutions">
                <ng-template mat-tab-label>
                    Solutions &nbsp;
                    <i class="fa fa-circle text-success" [hidden]="!displayNewSolutions"></i>
                </ng-template>
                <!--                <img class="loading-gif" src="../../../assets/img/loader.gif" [hidden]="solLoaded">-->
                <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif">
                </div>
                <div class="form-group col-sm-12 mar-top-15 textareadiv">
                <textarea class="form-control radius-0 font-13 ie-textarea sol-com-height edge-textarea"
                          placeholder="Put your solution here" [(ngModel)]="solution" [readonly]="!canAddSolution || isCancel"
                          maxlength="1000" mwlResizable
                          [enableGhostResize]="false"
                          resizeCursorPrecision="10"
                          [resizeEdges]="{bottom: true, right: true, top: false, left: false}"
                          (resizeEnd)="onResizeSolEnd($event)"
                          [disabled]="isCreateTicket"
                          [style.height.px]="solHeight"></textarea>
                    <div class="warning-msg" [hidden]="!canAddSolution">
                        *maximum 1000 characters
                    </div>
                </div>
                <!--<div class="form-group col-sm-12">-->
                <!--<textarea class="form-control radius-0 font-13 height-120"-->
                <!--placeholder="Put your rca here" [(ngModel)]="rca"></textarea>-->
                <!--</div>-->
                <div class="col-sm-12 sol-div">

                    <button type="button" class="btn btn-success btn-block" (click)="addSolution()"
                            *ngIf="canAddSolution && !isCreateTicket && !isCancel">
                        Add Solution
                    </button>
                </div>
                <div class="col-sm-12 mar-top-15">

                    <div class="stepper-container vertical">
                        <div class="stepper">
                            <div class="step step-height" *ngFor="let solution of solutions;">
                                <div class="step-inner">
                                    <div class="step-circle"><span><i class="fa fa-user"></i></span></div>
                                </div>
                                <div class="step-content col-sm-12 mar-top-15 mar-lft-rgt-0">
                                    <div class="card radius-0">
                                        <div class="card-header radius-0 card-header-top stepper-head">
                                            <b>{{solution.name}}</b>
                                            <b class="right"> {{solution.createddate | date:'medium'}}</b>
                                        </div>
                                        <div class="card-body">
                                            {{solution.solutions}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab *ngIf="!attachTab" label="Attachments">
                <ng-template mat-tab-label>
                    Attachments &nbsp;
                    <i class="fa fa-circle text-success" [hidden]="!displayNewAttachment"></i>
                </ng-template>
                <table class="table font-13 mar-top-15 attachment">
                    <thead class="thead-dark">
                    <tr>
                        <th>File</th>

                        <th>Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let attachment of attachments;">
                        <td><a class="pointer" (click)="downloadFile(attachment.attachedFilePath)">{{attachment.actual_attachedFilePath}}</a></td>
                        <td>{{attachment.createDate| date:'medium'}}</td>
                    </tr>
                    </tbody>
                </table>
            </mat-tab>
            <mat-tab *ngIf="isAsset" label="View Asset Details">
                <div class="form-group mar-top-9">
                    <select class="custom-select offset-4 col-sm-4 radius-0 font-13" [(ngModel)]="masterNameSelected"
                            (change)="onMasterChange($event.target.selectedIndex)">
                        <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
                    </select>
                </div>
                <div class="col-sm-12 height-386" *ngIf="showGrid">
                    <angular-slickgrid gridId="grid2"
                                       [columnDefinitions]="columnDefinitions1"
                                       [gridOptions]="gridOptions1"
                                       (onAngularGridCreated)="angularGridReady1($event)"
                                       gridWidth="1800"
                                       (sgOnClick)="onCellClicked1($event.detail.eventData, $event.detail.args)"
                                       (sgOnSelectedRowsChanged)="handleSelectedRowsChanged1($event.detail.eventData, $event.detail.args)"
                                       [dataset]="data">
                    </angular-slickgrid>
                </div>
            </mat-tab>
            <mat-tab *ngIf="isAsset" label="Add Asset Details">
                <div class="form-group row mar-top-9">
                    <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>
                    <div class="col-md-3">
                        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="masterDataNameSelected"
                                (change)="onMasterChange1($event.target.selectedIndex)">
                            <option *ngFor="let master of masterNameObj"
                                    [value]="master.id">{{master.masterName}}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="columnNameSelected"
                                (change)="onClientChange($event.target.selectedIndex)">
                            <option *ngFor="let column of columnDataObj"
                                    [value]="column.columnId">{{column.columnName}}</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="assetValue"
                               placeholder="Digital Asset value">
                    </div>
                    <div class="col-md-3">
                        <button type="button" class="btn btn-primary radius-0 font-13" (click)="onMasterDataChange()">
                            Submit
                        </button>
                    </div>
                </div>
                <!--                <div class="form-group mar-top-9">-->
                <!--                    <select class="custom-select offset-4 col-sm-4 radius-0 font-13"-->
                <!--                            [(ngModel)]="masterDataNameSelected"-->
                <!--                            (change)="onMasterDataChange()">-->
                <!--                        <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>-->
                <!--                    </select>-->
                <!--                </div>-->
                <div class="col-sm-12 height-386" *ngIf="showGrid1">
                    <angular-slickgrid gridId="grid3"
                                       [columnDefinitions]="columnDefinitions2"
                                       [gridOptions]="gridOptions2"
                                       (onAngularGridCreated)="angularGridReady2($event)"
                                       gridWidth="1800"
                                       (sgOnSelectedRowsChanged)="handleSelectedRowsChanged2($event.detail.eventData, $event.detail.args)"
                                       [dataset]="data2">
                    </angular-slickgrid>
                </div>
                <div class="row mar-left-rgt-15">
                    <div class="col-sm-6">
                        <button type="button"
                                class="btn btn-primary btn-block radius-0 font-13 col-md-6 offset-4 mar-top-9"
                                (click)="saveAssetData()">Save
                        </button>
                    </div>
                    <div class="col-sm-3 mar-top-9">
                        <ngb-pagination [collectionSize]="collectionSize" [maxSize]="5"
                                        (pageChange)="onPageChange($event)"
                                        [(page)]="page"
                                        [pageSize]="pageSize"></ngb-pagination>
                    </div>
                </div>
            </mat-tab>
            <mat-tab *ngIf="isViewIncident" label="View Ticket">
                <div class="col-sm-12 height-450" *ngIf="showGridForViewIncident">
                    <angular-slickgrid gridId="grid3"
                                       [columnDefinitions]="columnDefinitions3"
                                       [gridOptions]="gridOptions3"
                                       (onAngularGridCreated)="angularGridReady3($event)"
                                       gridWidth="2200"
                                       (sgOnClick)="onCellClicked3($event.detail.eventData, $event.detail.args)"
                                       [dataset]="viewIncidentData">
                    </angular-slickgrid>
                </div>
            </mat-tab>
            <mat-tab *ngIf="isAddIncident" label="Add Incident">
                <!--===================================================================-->
                <div class="shadow  mar-top-9">
                    <div class="row mar-lft-rgt-0 ticketid">
                        <input type="text" class="form-control font-13 col-sm-6 radius-0 mar-bot-10"
                               [(ngModel)]="searchTid"
                               id="ticketId"
                               placeholder="Enter Ticket Id">&nbsp;
                        <button type="button" class="btn btn-primary font-13 radius-0 col-sm-2 mar-bot-10"
                                (click)="searchTicket('inci')">Search
                            Ticket
                        </button>
                        <div class="height-40 col-sm-2 mar-bot-10" [hidden]="ticketIdSearchLoaded">
                            <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
                        </div>
                    </div>
                </div>
                <div class="shadow mar-bot-18 mar-top-9">
                    <div class="form-inline">

                        <div class="form-group col-sm-3">
                            <mat-form-field>
                                <mat-label>Select Status</mat-label>
                                <mat-select [(ngModel)]="searchStatusSelected">
                                    <mat-option *ngFor="let status of allStatus" [value]="status.id"
                                    >{{status.status}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="form-group col-sm-3">
                            <input [owlDateTimeTrigger]="dt9" [owlDateTime]="dt9" class="form-control radius-0 font-13"
                                   [(ngModel)]="fromDate" placeholder='Start Date'>
                            <owl-date-time [pickerType]="'calendar'" #dt9></owl-date-time>
                        </div>
                        <div class="form-group col-sm-3">
                            <input [owlDateTimeTrigger]="dt10" [owlDateTime]="dt10"
                                   class="form-control radius-0 font-13"
                                   [(ngModel)]="toDate" placeholder='End Date'>
                            <owl-date-time [pickerType]="'calendar'" #dt10></owl-date-time>
                        </div>
                    </div>
                    <div class="row mar-lft-rgt-0">
                        <div class="col-md-12 inci-cat-pad">
                            <div class="height-40" [hidden]="categoryLoaded">
                                <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
                            </div>
                            <select class="custom-select  tcktyp" *ngFor="let ticket of inciCategories;"
                                    [disabled]="ticket.isDisabled" [hidden]="!categoryLoaded"
                                    (change)="onSearchCategoryChange(ticket,$event.target.value) "
                            >
                                <option *ngFor="let option of ticket.options"
                                        [value]="option|json">{{option.title}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mar-lft-rgt-0">
                        <button type="button" class="btn btn-primary font-13 radius-0 offset-2 col-sm-2 mar-bot-10"
                                (click)="searchTicketWithFilter(query,1)">Search Ticket
                        </button>
                        <div class="height-40 col-sm-2 mar-bot-10" [hidden]="filterSearchLoaded">
                            <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
                        </div>
                    </div>
                </div>
                <!--=============================================================================-->
                <span class="totalitem"><b>Total items: </b> {{totalSearchItems}}</span>
                <div class="col-sm-12 height-250" *ngIf="showGridForAddIncident">
                    <angular-slickgrid gridId="grid4"
                                       [columnDefinitions]="columnDefinitions4"
                                       [gridOptions]="gridOptions4"
                                       (onAngularGridCreated)="angularGridReady4($event)"
                                       gridWidth="2200"
                                       (sgOnSelectedRowsChanged)="handleSelectedRowsChanged4($event.detail.eventData, $event.detail.args)"
                                       [dataset]="addIncidentData">
                    </angular-slickgrid>
                </div>
                <div class="row">
                    <button type="button" class="btn btn-success btn-block radius-0 font-13 col-md-6  mar-top-9"
                            (click)="addTicket()">Add Ticket ({{ticketCount}})
                    </button>
                    <button type="button" class="btn btn-primary btn-block radius-0 font-13 col-md-6  mar-top-9"
                            (click)="saveIncidentData()">Save
                    </button>
                </div>
            </mat-tab>
            <mat-tab *ngIf="isAddTicket" label="Add Ticket">
                <!--===================================================================-->
                <div class="shadow  mar-top-9">
                    <div class="row mar-lft-rgt-0 ticketid">
                        <input type="text" class="form-control font-13 col-sm-6 radius-0 mar-bot-10"
                               [(ngModel)]="searchTid"
                               id="ticketId"
                               placeholder="Enter Ticket Id">&nbsp;
                        <button type="button" class="btn btn-primary font-13 radius-0 col-sm-2 mar-bot-10"
                                (click)="searchTicketMinimal()">Search
                            Ticket
                        </button>
                        <div class="height-40 col-sm-2 mar-bot-10" [hidden]="ticketIdSearchLoaded">
                            <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
                        </div>
                    </div>

                </div>
                <span class="totalitem"><b>Total items: </b> {{totalSearchItems}}</span>
                <div class="col-sm-12 height-250" *ngIf="showGridForAddTicket">
                    <angular-slickgrid gridId="grid6"
                                       [columnDefinitions]="columnDefinitions6"
                                       [gridOptions]="gridOptions6"
                                       (onAngularGridCreated)="angularGridReady6($event)"
                                       (sgOnSelectedRowsChanged)="handleSelectedRowsChanged6($event.detail.eventData, $event.detail.args)"
                                       [dataset]="addTicketData">
                    </angular-slickgrid>
                </div>
                <div class="row">
                    <button type="button" class="btn btn-success btn-block radius-0 font-13 col-md-6  mar-top-9"
                            (click)="addTicket()">Add Ticket ({{ticketCount}})
                    </button>
                    <button type="button" class="btn btn-primary btn-block radius-0 font-13 col-md-6  mar-top-9"
                            (click)="saveIncidentData()">Save
                    </button>
                </div>
            </mat-tab>
            <mat-tab *ngIf="!logTab" label="Activity Logs">
                <table class="table font-13 mar-top-15 activity">
                    <thead class="thead-dark">
                    <tr>
                        <th>Username</th>
                        <th>Action</th>
                        <th>Action Description</th>
                        <th>Action Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let log of logs;">
                        <td>{{log.NAME}}</td>
                        <td>{{log.activity_desc}}</td>
                        <td>{{log.logValue}}</td>
                        <td>{{log.createdate| date:'medium'}}</td>
                    </tr>
                    </tbody>
                </table>
            </mat-tab>
            <mat-tab *ngIf="isRInfo" label="Requestor Info">
                <div class="mar-top-15" id="requestor-info">
                    <div class="container" *ngFor="let ps of psInfo">
                        <div class="form-group row mar-lft-rgt-0">
                            <label class="col-form-label col-sm-2 font-13">PS No.</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="psno" value="{{ps.psno}}"
                                       title="{{ps.psno}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">NAME</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="psname"
                                       value="{{ps.name}}" title="{{ps.name}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">STD Code</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="stdcode"
                                       value="{{ps.std_code}}" title="{{ps.std_code}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Phone No.</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="phone"
                                       value="{{ps.phone}}" title="{{ps.phone}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">IC</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="ic" value="{{ps.ic}}"
                                       title="{{ps.ic}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">SBU</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="sbu" value="{{ps.sbu}}"
                                       title="{{ps.sbu}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Status</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="status"
                                       value="{{ps.status}}" value="{{ps.status}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Band</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="band" value="{{ps.band}}"
                                       title="{{ps.band}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Grade</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="grade"
                                       value="{{ps.grade}}" title="{{ps.grade}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Location</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="location"
                                       value="{{ps.location}}" title="{{ps.location}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Gender</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="gender"
                                       value="{{ps.gender}}" title="{{ps.gender}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Senior Management</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="sm" value="{{ps.sm}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Overseas</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="overseas"
                                       value="{{ps.overseas}}" title="{{ps.overseas}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">ISD Code</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="isdcode"
                                       value="{{ps.isd_code}}" title="{{ps.isd_code}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Mobile No.</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="mobile"
                                       value="{{ps.mobile_no}}" title="{{ps.mobile_no}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Email ID</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="email"
                                       value="{{ps.email_id}}" title="{{ps.email_id}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Created Date</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="createdate"
                                       value="{{ps.create_date}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Date of Separation</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="separatedate"
                                       value="{{ps.date_of_separation}}" [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Entity Code</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="entitycode"
                                       value="{{ps.entity_code}}" title="{{ps.entity_code}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">Unit</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="unit" value="{{ps.unit}}"
                                       title="{{ps.unit}}"
                                       [disabled]="true">
                            </div>
                            <label class="col-form-label col-sm-2 font-13">DOJ</label>
                            <div class="col-sm-2">
                                <input type="text" class="form-control font-13 radius-0" name="doj" value="{{ps.doj}}"
                                       title="{{ps.doj}}"
                                       [disabled]="true">
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab *ngIf="activateUserReplay" label="User's Reply">
                <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif">
                </div>
                <div class="mar-top-15 offset-sm-2 col-sm-8">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label font-13">Query / Feedback from Analyst :</label>
                        <div class="col-sm-8">
                      <textarea class="form-control radius-0 font-13 height-80"
                                placeholder="Put your reply here" [(ngModel)]="lastComment" disabled
                                title="{{lastComment}}"></textarea>

                        </div>
                    </div>
                    <div class="col-sm-6 pad-15 text-center">
                        <app-material-fileupload [target]="fileUploadUrl" [text]="uploadButtonName"
                                                 [formData]="formdata"
                                                 [maxFile]="MAX_FILE_UPLOAD"
                                                 (uploadError)="onFileError($event)"
                                                 (complete)="onFileCompleteReply($event)"
                                                 (dataLoaded)="onUpload($event)"
                                                 [isVisible]="!isCreateTicket">

                        </app-material-fileupload>
                    </div>
                    <div class="col-sm-6 pad-15 text-center upload-msg" [hidden]="replyHideAttachment">{{attachMsg}}
                        uploaded
                        successfully
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label font-13">User's Reply</label>
                        <div class="col-sm-8">
                       <textarea class="form-control radius-0 font-13 height-80"
                                 placeholder="Put your reply here" [(ngModel)]="usersReply"
                                 maxlength="1000" [disabled]="isCreateTicket"></textarea>
                            <div class="warning-msg">
                                *maximum 1000 characters
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row mar-lft-rgt-0">
                    <button class="btn btn-success font-13 radius-0 offset-sm-5 col-sm-2" type="button"
                            (click)="submitUserReply()" [hidden]="isCreateTicket">
                        Submit
                    </button>
                    <!--                    <div class="height-40 col-sm-2 " [hidden]="!isUserReplied">-->
                    <!--                        <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">-->
                    <!--                    </div>-->
                </div>
            </mat-tab>
            <mat-tab *ngIf="isAttachTicket" label="Attach Child Ticket">
                <div class="selectone">
                    <mat-radio-group aria-label="Select an option" [(ngModel)]="selectForChildTicket"
                                     (ngModelChange)="changeForChildTicket()">
                        <mat-radio-button value="exist">Add existing one</mat-radio-button>
                        <mat-radio-button value="new">Create new one</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div *ngIf="!isDisplayCreateTicket">
                    <app-create-ticket-cit [parrentTicketId]="tId" [wfcresultId]="wfcresultId"></app-create-ticket-cit>
                </div>
                <div class="mainExist">
                    <div [hidden]="isDisplayExistingTicket">
                        <input type="text" class="form-control font-13 col-sm-6 radius-0 mar-bot-10"
                               [(ngModel)]="searchTid"
                               id="ticketId1"
                               placeholder="Enter Ticket Id">&nbsp;
                        <button type="button" class="btn btn-primary font-13 radius-0 col-sm-2 mar-bot-10"
                                (click)="searchTicket('child')">Search
                            Ticket
                        </button> &nbsp;&nbsp;
                        <button type="button" class="btn btn-warning font-13 radius-0 col-sm-2 mar-bot-10"
                                (click)="addChildTicket()">Attach Ticket
                        </button>
                        <!--<mat-autocomplete #auto="matAutocomplete">
                          <mat-option *ngFor="let option of options" [value]="option">{{option}}</mat-option>
                        </mat-autocomplete>-->

                        <div class="col-sm-12 height-250" *ngIf="showGridForAttachTicket">
                            <angular-slickgrid gridId="grid5"
                                               [columnDefinitions]="columnDefinitions5"
                                               [gridOptions]="gridOptions5"
                                               (onAngularGridCreated)="angularGridReady5($event)"
                                               gridWidth="2200"
                                               (sgOnSelectedRowsChanged)="handleSelectedRowsChanged5($event.detail.eventData, $event.detail.args)"
                                               [dataset]="addIncidentData">
                            </angular-slickgrid>
                        </div>
                    </div>
                </div>
            </mat-tab>
            <mat-tab *ngIf="isChecklist" label="Checklist">
                <span class="checklist-title"><u>Checklist</u></span>
                <div class="checklist-div">
                    <div class="form-group font-13 checklist" *ngFor="let checklist of checklistData">
                        <div class="row">
                            <div class="col-sm-6">
                                {{checklist.description}}
                            </div>
                            <div class="col-sm-6">
                                {{checklist.answer}}
                            </div>
                        </div>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</ng-template>
<ng-template #groupSelect>
    <select class="custom-select radius-0 font-13" [(ngModel)]="userGroupSelected" (change)="onSelectGroup()">
        <option *ngFor="let group of userGroups" [value]="group.groupId">{{group.grpName}}</option>
    </select>
</ng-template>
<ng-template #statusChange>
    <div class="form-group col-sm-12 pad-lft-0 desc-div">
  <textarea class="form-control radius-0 font-13 ie-textarea edge-textarea" type="text" [(ngModel)]="statusComment"
            placeholder="Enter Comments before changing status"
            mwlResizable
            [enableGhostResize]="false"
            resizeCursorPrecision="10"
            maxlength = '1000'
            [resizeEdges]="{bottom: true, right: true, top: false, left: false}"
            (resizeEnd)="onStatusResizeEnd($event)"
            [style.height.px]="statusHeight"></textarea>
    </div>
    <div class="row mar-lft-rgt-0">
        <button type="button" class="btn btn-success font-13 radius-0 mar-top-9" (click)="changeStatus()">Submit
        </button>
        <div class="height-40 col-sm-2  mar-top-9" [hidden]="!isChangeStatus">
            <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
    </div>
</ng-template>
<ng-template #addCommentMessage>
    <div class="form-group col-sm-12 pad-lft-0 desc-div">
  <textarea class="form-control radius-0 font-13 ie-textarea edge-textarea" type="text" [(ngModel)]="comment"
            placeholder="Enter Comments before forwarding"
            mwlResizable
            [enableGhostResize]="false"
            resizeCursorPrecision="10"
            maxlength = '1000'
            [resizeEdges]="{bottom: true, right: true, top: false, left: false}"
            (resizeEnd)="onStatusResizeEnd($event)"
            [style.height.px]="statusHeight"></textarea>
    </div>
    <div class="row mar-lft-rgt-0">
        <button type="button" class="btn btn-success font-13 radius-0 mar-top-9" (click)="addComment('forward')">Submit
        </button>
        <div class="height-40 col-sm-2  mar-top-9" [hidden]="!isChangeStatus">
            <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
    </div>
</ng-template>

<ng-template #checklist let-c="close" let-d="dismiss">
    <div class="modal-header checklistTitle">
        <div class="modal-title">Check List</div>

    </div>
    <div class="modal-body height-450">
        <div class="form-group font-13" *ngFor="let checklist of checkLists">
            <!-- <mat-checkbox value="{{checklist.id}}" (change)="selectCheckBox(checklist.checked)"
                          [(ngModel)]="checklist.checked">{{checklist.description}} </mat-checkbox> -->
            <div class="row">
                <div class="col-6">
                    <p>{{checklist.description}}</p>
                </div>
                <div class="col-6">
                    <p *ngIf="checklist.fieldType === '1'">
                        <mat-form-field class="example-full-width">
                            <input matInput placeholder="Type here" [(ngModel)]="checklist.answer">
                        </mat-form-field>
                    </p>
                    <p *ngIf="checklist.fieldType === '3'">
                        <!--                        <select class="custom-select  tcktyp" [(ngModel)]="checklist.answer">-->
                        <!--                            <option *ngFor="let option of checklist.predifinedValue"-->
                        <!--                                    [value]="option">{{option}}</option>-->
                        <!--                        </select>-->
                        <mat-form-field>
                            <mat-select [(ngModel)]="checklist.answer">
                                <mat-option *ngFor="let option of checklist.predifinedValue" [value]="option"
                                >{{option}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </p>
                    <p *ngIf="checklist.fieldType === '2'">
                        <input [owlDateTimeTrigger]="dt1" placeholder="Enter Date " [owlDateTime]="dt1"
                               class="radius-0 font-13" [(ngModel)]="checklist.answer">
                        <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
                    </p>
                    <p *ngIf="checklist.fieldType === '4'">
                        <!--                        <mat-form-field>-->
                        <!--                            <textarea matInput placeholder="Type here" [(ngModel)]="checklist.answer"></textarea>-->
                        <!--                        </mat-form-field>-->
                        <textarea class="form-control radius-0 font-13 edge-textarea brief-desc"
                                  placeholder="Type here" [(ngModel)]="checklist.answer"
                                  mwlResizable
                                  [enableGhostResize]="false"
                                  resizeCursorPrecision="100"
                                  [resizeEdges]="{bottom: true, right: false, top: false, left: false}"
                                  (resizeEnd)="onResizeEnd($event)"
                                  [style.height.px]="height"></textarea>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="save_ticket_checklist()">Submit</button>
        <button type="button" class="btn btn-info radius-0" (click)="addAsset()">Attach / Update Asset</button>
        <button type="button" class="btn btn-danger radius-0" (click)="closeDialog()">Cancel</button>
    </div>
</ng-template>
<ng-template #addUpdateAsset>
  <span class="close"
        (click)="closeAssetModify()" aria-hidden="true">&times;</span>
    <mat-tab-group (selectedTabChange)="assetTabClick($event)">
        <mat-tab label="Generate Asset ID">
            <app-asset-description ></app-asset-description>
        </mat-tab>
        <mat-tab label="Add Asset Value">
            <app-it-asset-management-value [isModifyAsset]="true" [ticketId]=tId *ngIf="showAssetdatagrid"></app-it-asset-management-value>
        </mat-tab>
        <mat-tab label="Update Asset">
            <app-asset-search [ticketId]=tId></app-asset-search>
        </mat-tab>
    </mat-tab-group>
</ng-template>
